import { render, staticRenderFns } from "./grid-widget.vue?vue&type=template&id=710833d6&"
import script from "./grid-widget.vue?vue&type=script&lang=ts&"
export * from "./grid-widget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports